export default {
  input: {
    flex: '1 1 auto',
    position: 'relative',
    fontSize: '12px',
    lineHeight: '16px',
    maxHeight: 150,
    padding: '10px',
    boxShadow: 'none',
    border: 'none',
    outline: 'none',
    overflowY: 'auto',
    display: 'block',
    cursor: 'text',
  },
};
